import React from 'react'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import {toast} from 'react-toastify'
import FileHandler from '../layout/file-handler/fileHandler'

class ColourEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            breadcrumb: {title: 'Back to Colours', path: '/colours'},
            fields: {
                label: {label: 'Colour name', type: 'text', required: true},
            },
            colour: null
        }
    }

    createCorrectBannerUrl = (image) => {
        let urlPrefix = 'storage/colour-banner/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    componentDidMount() {
        API.getColour(this.props.match.params.colourId).then(colour => {
            var bannerImage = {}
            var coverImage = {}

            if (colour.banner) {
                bannerImage = this.createCorrectBannerUrl(colour.banner)
            }

            if (colour.cover) {
                coverImage = this.createCorrectCoverUrl(colour.cover)
            }

            this.setState({
                loading: false,
                colour: colour,
                tempBanner: bannerImage,
                tempCover: coverImage,
            })
        })
    }

    // Banner image
    showBannerImage = (file, fileObj, type, index) => {
        var colour = this.state.colour
        colour.banner = this.createCorrectBannerUrl(fileObj)

        this.setState(previousState => ({
            colour,
            tempBanner: colour.banner
        }))
    }

    removeBannerImage = () => {
        this.setState(previousState => ({
            colour: {
                ...this.state.colour,
                banner: null
            },
            tempBanner: null,
        }))
    }

    createCorrectCoverUrl = (image) => {
        let urlPrefix = 'storage/colour-cover/'

        let urlEnd = image.uri
        let url = urlPrefix + urlEnd

        image.uri = url
        return image
    }

    // Cover image
    showCoverImage = (file, fileObj, type, index) => {
        var colour = this.state.colour
        colour.cover = this.createCorrectCoverUrl(fileObj)

        this.setState(previousState => ({
            colour,
            tempCover: colour.cover
        }))
    }

    removeCoverImage = () => {
        this.setState(previousState => ({
            colour: {
                ...this.state.colour,
                cover: null
            },
            tempCover: null,
        }))
    }

    // Content block
    addContentBlock = () => {
        const content = this.state.colour.content

        const newBlock = {
            title: {
                en: '',
                zh: ''
            },
            description: {
                en: '',
                zh: ''
            },
        }

        const newBlocks = [...content, newBlock]

        this.setState({
            colour: {
                ...this.state.colour,
                content: newBlocks
            }
        })
    }

    removeContentBlock = (index) => {
        var r = window.confirm("Are you sure you want to delete this block?");
        if (r === false) return

        let content = this.state.colour.content

        content.splice(index, 1)

        this.setState(prevState => ({
            ...prevState,
            content
        }))
    }

    handleChange = (e, element, subElement, lang, index = 0) => {
        var newValue = e
        let {colour} = this.state

        if (element === 'content') {
            colour[element][index][subElement][lang] = newValue
        } else {
            if (lang == '') {
                colour[element][subElement] = newValue
            } else {
                colour[element][subElement][lang] = newValue
            }
        }

        this.setState(previousState => ({
            ...previousState,
            colour
        }))
    }

    updateField(e, key) {
        this.setState({
            colour: {
                ...this.state.colour,
                [key]: e.target.value
            }
        })
    }

    saveEntity = (updatedEntity) => {
        this.setState({loading: true})

        if (!this.state.colour.name?.en || !this.state.colour.name?.zh) {
            toast.error('Colour\'s name can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.banner) {
            toast.error('Colour\'s banner can not be empty')
            this.setState({loading: false})
            return
        } else if (!updatedEntity.cover) {
            toast.error('Colour\'s cover can not be empty')
            this.setState({loading: false})
            return
        }

        let bannerUri = updatedEntity.banner.uri.replace('storage/colour-banner/', '')
        updatedEntity.banner.uri = bannerUri

        let coverUri = updatedEntity.cover.uri.replace('storage/colour-cover/', '')
        updatedEntity.cover.uri = coverUri

        API.update('colours', this.props.match.params.colourId, updatedEntity).then(() => {
            toast.success('Colour has been updated')
            this.props.history.push('/colours')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    deleteEntity = () => {
        var r = window.confirm("Are you sure you want to delete this colour?");
        if (r === false) return

        this.setState({loading: true})
        API.deleteColour(this.props.match.params.colourId).then(() => {
            toast.success('Colour was successfully deleted')
            this.props.history.push('/colours')
        }).catch(() => {
            toast.error('An unexpected error has occured, please try again')
            this.setState({loading: false})
        })
    }

    onCancel(e, callback) {
        e.preventDefault()
        callback()
    }

    onSubmit(e, callback) {
        e.preventDefault()
        callback()
    }

    render() {
        if (this.state.loading)
            return <Loader/>
        else
            return <>
                <Head title={'Edit colour'}/>
                <Content>
                    <form onSubmit={(e) => {
                        this.onSubmit(e, () => this.saveEntity(this.state.colour))
                    }} className="custom-form">
                        <div className="actions clearfix">
                            <div className="buttons clearfix">
                                <button className="grey"
                                        onClick={(e) => this.onCancel(e, () => this.props.history.push('/colours'))}>Cancel
                                </button>
                                <button className="blue">Save colour</button>
                            </div>
                        </div>

                        <div className="block above">
                            <div className="fields container clearfix">
                                <h3>Information</h3>
                                <div className="field" key="nameEn">
                                    <label>Name in English</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'en', '')}
                                           value={this.state.colour?.name?.en || ""}/>
                                </div>
                                <div className="field" key="nameZh">
                                    <label>Name in Chinese</label>
                                    <input type="text"
                                           onChange={(e) => this.handleChange(e.target.value, 'name', 'zh', '')}
                                           value={this.state.colour?.name?.zh || ""}/>
                                </div>
                                <div className="field" key="banner">
                                    <div className="file-handler-container">
                                        {this.state.tempBanner &&
                                        <FileHandler
                                            image={this.state.tempBanner.uri}
                                            name={this.state.tempBanner.name}
                                            removeImage={(type) => this.removeBannerImage(type)}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'colour-banner'}
                                        />
                                        }

                                        {!this.state.tempBanner &&
                                        <FileHandler
                                            showImage={this.showBannerImage}
                                            type={'images'}
                                            label={'Banner'}
                                            fileType={'images'}
                                            path={'colour-banner'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>
                                <div className="field" key="cover">
                                    <div className="file-handler-container">
                                        {this.state.tempCover &&
                                        <FileHandler
                                            image={this.state.tempCover.uri}
                                            name={this.state.tempCover.name}
                                            removeImage={(type) => this.removeCoverImage(type)}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'colour-cover'}
                                        />
                                        }

                                        {!this.state.tempCover &&
                                        <FileHandler
                                            showImage={this.showCoverImage}
                                            type={'images'}
                                            label={'Cover'}
                                            fileType={'images'}
                                            path={'colour-cover'}
                                            dropzone
                                        />
                                        }
                                    </div>
                                </div>

                                <div className="long-field" key="descriptionEn">
                                    <label>Description in English</label>
                                    <textarea type="text"
                                        onChange={(e) => this.handleChange(e.target.value, 'description', 'en', '')}
                                        value={this.state.colour?.description.en || ""}
                                    />
                                </div>

                                <div className="long-field" key="descriptionZh">
                                    <label>Description in Chinese</label>
                                    <textarea type="text"
                                        onChange={(e) => this.handleChange(e.target.value, 'description', 'zh', '')}
                                        value={this.state.colour?.description.zh || ""}
                                    />
                                </div>
                            </div>

                            <div className="fields container clearfix">
                                <h3>Content</h3>

                                {
                                    Object.keys(this.state.colour.content).map(index => {
                                        return (
                                            <div className="fields container clearfix">
                                                <div>
                                                    <p style={{
                                                        textDecoration: 'underline'
                                                    }}>{parseInt(index) + 1}. Block {parseInt(index) + 1}
                                                    </p>
                                                    <label style={{
                                                        textDecorationLine: 'underline',
                                                        color: '#2196F3',
                                                        position: 'absolute',
                                                        right: '32px',
                                                        cursor: 'pointer'
                                                    }}
                                                           onClick={() => {
                                                               this.removeContentBlock(index)
                                                           }}
                                                    >Delete
                                                    </label>
                                                </div>

                                                <div className="field" key="titleEn">
                                                    <label>Title in English</label>
                                                    <input type="text"
                                                           onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'en', index, false)}
                                                           value={this.state.colour?.content[index].title.en || ""}/>
                                                </div>

                                                <div className="field" key="titleZh">
                                                    <label>Title in Chinese</label>
                                                    <input type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'title', 'zh', index, false)}
                                                        value={this.state.colour?.content[index].title.zh || ""}/>
                                                </div>

                                                <div className="long-field" key="descriptionEn">
                                                    <label>Description in English</label>
                                                    <textarea type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'en', index)}
                                                        value={this.state.colour?.content[index].description.en || ""}
                                                    />
                                                </div>

                                                <div className="long-field" key="descriptionZh">
                                                    <label>Description in Chinese</label>
                                                    <textarea type="text"
                                                        onChange={(e) => this.handleChange(e.target.value, 'content', 'description', 'zh', index)}
                                                        value={this.state.colour?.content[index].description.zh || ""}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                                <div className="buttons">
                                    <button className="blue add clearfix"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.addContentBlock()
                                            }}>
                                        Add new block
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="actions clearfix below-form">
                        <button onClick={() => this.deleteEntity()} className="red">Delete colour</button>
                    </div>
                </Content>
            </>
    }
}

export default ColourEdit